import styled from 'styled-components';

export const StyleContent = styled.div`
  min-height: 100vh;
  background: ${(props) => (props.bgColor ? props.bgColor : 'E7E7E7')};
  padding-top: ${(props) =>
    props.paddingTop ? `${props.paddingTop}px;` : '120px;'};
  position: relative;
`;
